import React, {createRef, forwardRef, useEffect, useState} from 'react';
import Autocomplete, {ReactGoogleAutocompleteInputProps, usePlacesWidget} from "react-google-autocomplete";
import {Input, InputLabel, TextField} from "@mui/material";
import i18n from "i18next";
import {InputProps} from "@mui/material/Input/Input";
import {TextFieldProps} from "@mui/material/TextField/TextField";

export interface IGoogleAutocompleteWrapperProps {
    inputProps?: TextFieldProps;
    googleInputProps?: ReactGoogleAutocompleteInputProps;
}

const GoogleAutocompleteWrapper = (props: IGoogleAutocompleteWrapperProps) => {
    // @ts-ignore
    const apiKey = window?.appConfig?.ENV === 'PROD' ? process.env.REACT_APP_GOOGLE_APY_KEY_PROD : process.env.REACT_APP_GOOGLE_APY_KEY_DEV;
    const [language, setLanguage] = useState<string>("en-GB");

    useEffect(() => {
        switch (i18n.resolvedLanguage) {
            case 'fr':
            case 'fr-FR':
                setLanguage('fr');
                break;
            case 'it':
            case 'it-IT':
                setLanguage('it');
                break;
            default:
                setLanguage('en-GB');
        }
    }, [i18n.resolvedLanguage]);

    const { ref: materialRef } = usePlacesWidget({
        ...props.googleInputProps,
        language: i18n.resolvedLanguage,
        apiKey: apiKey
    });

    return (
        <>
            <TextField
                {...props.inputProps}
                onKeyDown={(e) => {
                    if (e.key === 'Tab') {
                        e.preventDefault();
                    }
                }}
                inputRef={materialRef}
            />
        </>
        /*<>
            <InputLabel sx={{color: "primary"}}>{props.label}</InputLabel>
            <Input
                fullWidth
                sx={{
                    marginBottom: '4px'
                }}
                inputProps={{
                    sx: {
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat'
                    }
                }}
                {...props.inputProps}
                inputComponent={forwardRef(({...propsInt}, ref) => (
                    <Autocomplete
                        apiKey={apiKey}
                        {...propsInt}
                        {...props.googleInputProps}
                        language={language}
                    />
                ))}
            />
        </>*/
    );
};

export default GoogleAutocompleteWrapper;
